<template>
  <div
    :class="[
      showValidationErrors &&
      (shouldShowSignerNameValidation || shouldShowW8SubstituteValidation)
        ? 'relative mb-5'
        : question?.is_type == 'group'
          ? 'mb-2'
          : 'mb-2',
    ]"
  >
    <div
      v-if="question?.show_subject !== false"
      class="flex items-start"
      :class="[!question?.description ? 'mb-1' : '']"
    >
      <p
        v-if="!question?.is_html_subject"
        class="text-dark-blue"
      >
        {{ subject }}
      </p>
      <div
        v-else
        class="text-sm"
        v-html="question?.subject"
      />
      <slot />
    </div>
    <p
      v-if="question?.description"
      class="mb-1 text-xxs font-bold uppercase text-gray-over-dark"
    >
      {{ question.description }}
    </p>
    <input
      v-model="answer"
      class="w-full rounded p-4"
      :class="[
        showValidationErrors &&
        (shouldShowSignerNameValidation || shouldShowW8SubstituteValidation)
          ? 'failed-validation border border-red-500 bg-red-100 text-red-500 focus:border-red-500 focus:bg-red-100 focus:text-red-500'
          : 'border border-transparent bg-off-white text-sm hover:border-placeholder-gray focus:bg-white focus:text-dark-gray',
      ]"
      type="text"
      :placeholder="question?.group_parent_id == 160 ? question?.subject : ''"
      @input="handleInput"
    />
    <div
      v-if="
        showValidationErrors &&
        (shouldShowSignerNameValidation || shouldShowW8SubstituteValidation)
      "
      class="absolute pl-1 pt-1 text-3xs text-red-500"
    >
      This field is required.
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextInput',
  props: {
    question: Object,
    question_id: Number,
    subject: String,
    currentTaxFormId: Number,
    onboardingPacketId: Number,
    setTaxAnswers: Function,
    toggleRequired: Function,
    required: Boolean,
    conditional_children: Array,
    currentAnswerObject: [Object, Boolean],
  },
  emits: ['child-check', 'group-check'],
  data() {
    return {
      answer: '',
    };
  },
  computed: {
    shouldShowSignerNameValidation() {
      return (
        this.question?.is_required &&
        this.question?.subject == 'Signer Name' &&
        this.answer?.length < 1
      );
    },
    shouldShowW8SubstituteValidation() {
      return (
        this.question?.is_required &&
        [233, 240, 241, 242].includes(this.question?.id) &&
        this.answer?.length < 1
      );
    },
    isSignerName() {
      return this.question?.subject == 'Signer Name';
    },
    currentTaxForm() {
      return this.$store.state.taxQuestions.current_tax_form;
    },
    showValidationErrors() {
      if (this.currentTaxForm?.length < 1) return false;
      return this.$store.state.taxQuestions.show_validation_errors[
        this.currentTaxForm
      ];
    },
  },
  created() {
    if (this.currentAnswerObject && this.currentAnswerObject !== false) {
      if (!this.isSignerName) {
        this.answer = this.currentAnswerObject?.string_value;
        this.presetSavedAnswer();
      } else {
        if (
          this.$store.state.users.currentUser?.first_name &&
          this.$store.state.users.currentUser?.last_name &&
          `${this.$store.state.users.currentUser?.first_name} ${this.$store.state.users.currentUser?.last_name}` !==
            this.currentAnswerObject?.string_value
        ) {
          this.answer = `${this.$store.state.users.currentUser?.first_name} ${this.$store.state.users.currentUser?.last_name}`;
          this.presetSavedAnswer();
        } else {
          this.answer = this.currentAnswerObject?.string_value;
          this.presetSavedAnswer();
        }
      }
    }
  },
  methods: {
    handleInput(e) {
      let body = null;
      if (this.answer?.length > 0) {
        body = {
          onboarding_packet_id: this.onboardingPacketId,
          tax_form_id: this.currentTaxFormId,
          tax_question_id: this.question_id,
          string_value: e.target.value,
        };
      }
      // console.log('body: ');
      // console.dir(body);
      this.setTaxAnswers(body);
      if (this.required) {
        this.answer?.length > 0
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }
      this.emitForComparison(e.target.value);
    },
    emitForComparison(value) {
      if (this.conditional_children?.length > 0) {
        this.conditional_children.forEach((child) => {
          if (child?.evaluation_js?.length > 0 && child?.tax_question_id > 0) {
            this.$emit(
              'child-check',
              child.tax_question_id,
              value,
              child.evaluation_js,
              child.is_shown_by_default,
              child.is_required
            );
          }
        });
      }
      if (this.question?.group_parent_id !== null) {
        this.$emit(
          'group-check',
          this.question?.id,
          this.question?.group_parent_id,
          value
        );
      }
    },
    presetSavedAnswer() {
      let body = {
        onboarding_packet_id: this.onboardingPacketId,
        tax_form_id: this.currentTaxFormId,
        tax_question_id: this.question_id,
        string_value: this.answer,
      };
      this.setTaxAnswers(body);
      if (this.required) {
        this.answer
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }
      this.emitForComparison(this.answer);
    },
  },
};
</script>
